import styled from 'styled-components'
import Loader from 'components/Common/Loader'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`

const Loading = () => {
  return (
    <Wrapper>
      <Loader color='#3B42A5' size='30px' />
    </Wrapper>
  )
}

export default Loading
